import { PickupEventDetailPage } from "components/shared/pickupEvents";

const WPSCheckinEventsDetailPage = () => (
  <PickupEventDetailPage variant="wps" />
);

export default WPSCheckinEventsDetailPage;
